<template>
  <v-container fluid fill-height>
    <div id="mapDiv"></div>
  </v-container>
</template>

<style scoped>
#mapDiv {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  z-index: 0;
}
</style>

<script>

import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import gql from 'graphql-tag';

const SUBSCRIPTION_GEOFENCES = gql`
subscription get_geofences {
  geofences (
    where: {
    }
  ) {
    id
    enabled
    location
    radius
  }
}
`;

const SUBSCRIPTION_DEVICES = gql`
subscription get_devices {
  devices {
    id
    name
    location
  }
}
`;

const UPDATE_USER_MAPLAYER = gql`
mutation update_user_maplayer($sub: String!, $map_layer: String!) {
  update_users_by_pk(
    pk_columns: { sub: $sub },
    _set: {
      map_layer: $map_layer
    }
  ) {
    map_layer
  }
}
`;

export default {
  name: 'Locations',
  data() {
    return {
      map: null,
      markers: null,
      devices: [],
      geofences: null,
      ignoreLayerSelectionOnce: true,
      centerOnce: true,
    };
  },
  mounted() {
    // eslint-disable-next-line
    const mapBoxSatellite = L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/satellite-v9/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiaGVpa2tpcyIsImEiOiJjanp3YnBvaGwwZDR0M2hwZ29zdXZmeDh4In0.cxRko2MWKrQ520oi1G0_9A', {
      tileSize: 512,
      zoomOffset: -1,
      attribution: '© <a href="https://apps.mapbox.com/feedback/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    });
    // eslint-disable-next-line
    const mapBoxStreets = L.tileLayer('https://api.mapbox.com/styles/v1/mapbox/streets-v11/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiaGVpa2tpcyIsImEiOiJjanp3YnBvaGwwZDR0M2hwZ29zdXZmeDh4In0.cxRko2MWKrQ520oi1G0_9A', {
      tileSize: 512,
      zoomOffset: -1,
      attribution: '© <a href="https://apps.mapbox.com/feedback/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    });
    const openStreetMap = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    });
    const maanmittauslaitos = L.tileLayer('https://avoin-karttakuva.maanmittauslaitos.fi/avoin/wmts/1.0.0/maastokartta/default/WGS84_Pseudo-Mercator/{z}/{y}/{x}.png', { id: 'Maastokartta' });

    let defaultLayerName = this.$store.state.mapLayer;
    if (defaultLayerName === undefined || defaultLayerName === null) {
      console.log('defaultti');
      defaultLayerName = 'Maanmittauslaitos';
    } else {
      console.log(defaultLayerName);
    }

    const mapLayers = {
      // eslint-disable-next-line
      'MapBoxSatellite': mapBoxSatellite,
      // eslint-disable-next-line
      'MapBoxStreets': mapBoxStreets,
      // eslint-disable-next-line
      'OpenStreetMap': openStreetMap,
      // eslint-disable-next-line
      'Maanmittauslaitos': maanmittauslaitos,
    };

    this.map = L.map('mapDiv', {
      minZoom: 4,
      maxZoom: 18,
      zoomControl: false,
      layers: [mapLayers[defaultLayerName]],
    });
    this.map.on('baselayerchange ', this.layerSelected);

    L.control.layers(mapLayers, null, { position: 'topleft' }).addTo(this.map);

    this.markers = new L.FeatureGroup();
    this.map.addLayer(this.markers);
  },
  methods: {
    layerSelected(e) {
      if (this.ignoreLayerSelectionOnce) {
        this.ignoreLayerSelectionOnce = false;
        return;
      }
      // eslint-disable-next-line
      console.log('selected layer: ' + e.name);
      this.$store.commit('mapLayer', e.name);
      this.saveMapLayer();
    },
    editFence(e) {
      this.$store.commit('currentGeofenceId', e.target.geofenceId);
      this.$store.commit('currentMapZoomLevel', this.map.getZoom());
      this.$store.commit('cameFromView', 'Locations');
      this.$store.commit('currentDevice', null);
      this.$router.push({ name: 'Geofence' });
    },
    updateMarkers() {
      // console.log('devices');
      // console.log(this.devices);
      // console.log('geofences');
      // console.log(this.geofences);

      this.markers.clearLayers();

      let totalLat = 0;
      let totalLng = 0;
      let deviceCount = 0;

      if (this.devices) {
        this.devices.forEach((device) => {
          if (device && device.location && device.location.coordinates) {
            const marker = L.circleMarker([device.location.coordinates[0],
              device.location.coordinates[1]], {
              radius: 10, fillOpacity: 1, color: '#ff0000',
            }).addTo(this.markers);
            marker.bindPopup(device.name).openPopup();
          }
        });
      }

      if (this.geofences) {
        this.geofences.forEach((geofence) => {
          if (geofence && geofence.location && geofence.location.coordinates) {
            const marker = L.circle([geofence.location.coordinates[0],
              geofence.location.coordinates[1]], {
              radius: geofence.radius, fillOpacity: 0.25, color: geofence.enabled ? '#00ff00' : '#808080',
            }).addTo(this.markers);
            marker.on('click', this.editFence);
            marker.geofenceId = geofence.id;
            totalLat += geofence.location.coordinates[0];
            totalLng += geofence.location.coordinates[1];
            deviceCount += 1;
          }
        });
      }

      if (this.centerOnce) {
        if (this.$store.state.currentMapZoomLevel > 0) {
          this.map.setZoom(this.$store.state.currentMapZoomLevel);
        }
        if (this.$store.state.currentMapLocation) {
          this.map.panTo(this.$store.state.currentMapLocation);
          this.centerOnce = false;
        }
        if (this.centerOnce) {
          if (deviceCount > 0) {
            const avgLat = totalLat / deviceCount;
            const avgLng = totalLng / deviceCount;

            this.map.setView(new L.LatLng(avgLat, avgLng), 6);
          } else {
            this.map.setView(new L.LatLng(64.7914001, 25.4080717), 6);
          }
        }
        this.centerOnce = false;
      }
    },
    saveMapLayer() {
      // eslint-disable-next-line
      const sub = this.$store.state.user.attributes.sub;
      // eslint-disable-next-line
      const map_layer = this.$store.state.mapLayer;

      const variables = {
        sub,
        map_layer,
      };

      this.$apollo.mutate({
        mutation: UPDATE_USER_MAPLAYER,
        variables,
        // eslint-disable-next-line
        update: (cache, { data: { update_users } }) => {
          // TODO error handling what if mutation doesn't work
        },
      });
    },
  },
  apollo: {
    // Subscriptions
    $subscribe: {
      // When a user is added
      devices: {
        query: SUBSCRIPTION_DEVICES,
        // Result hook
        result(data) {
          this.devices = data.data.devices;
          this.updateMarkers();
        },
      },
      geofences: {
        query: SUBSCRIPTION_GEOFENCES,
        variables() {
          return {
            deviceId: this.deviceId,
          };
        },
        result(data) {
          this.geofences = data.data.geofences;
          this.updateMarkers();
        },
      },
    },
  },
};
</script>
